import Axios, { AxiosPromise } from 'axios';
interface CallPrinterResponse {
  RequestID: any;
  ResponseID: any;
  Result: 'ready' | 'error';
}
class BixolonLabelPrinterService {
  _printerAddress: string = '';
  _printerName: string = '';
  _wsPrint = null;
  init = (printerAddress: string, printerName: string) => {
    this._printerAddress = printerAddress;
    this._printerName = printerName;
    return this;
  };
  getServerUrl = () => {
    return `${this._printerAddress}/WebPrintSDK/${this._printerName}`;
  };
  getAxiosInstance = () => {
    return Axios.create({ baseURL: this.getServerUrl() });
  };
  checkPrinterStatus = (): Promise<boolean> => {
    const data = {
      func0: { checkLabelStatus: [] },
    };
    return new Promise(resolve => {
      this.callPrint(data)
        .then(res => {
          if (res.data.Result === 'ready') {
            const httpClient = this.getAxiosInstance();
            httpClient({
              url: '/checkStatus',
              method: 'POST',
              data: JSON.stringify({ RequestID: res.data.RequestID, ResponseID: res.data.ResponseID, Timeout: 30 }),
              headers: { 'content-type': 'application/x-www-form-urlencoded' },
            }).then(checkRes => {
              if (checkRes.data.Result === 'success') {
                resolve(true);
              } else {
                resolve(false);
              }
            });
          } else {
            resolve(false);
          }
        })
        .catch(() => {
          resolve(false);
        });
    });
  };

  callPrint = (printActions: any): AxiosPromise<CallPrinterResponse> => {
    const actionText = JSON.stringify({ id: 0, functions: printActions });
    const httpClient = this.getAxiosInstance();
    return httpClient({
      url: '/',
      method: 'POST',
      data: actionText,
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    }) as any;
  };

  //

  buildPrintActionFromArray = (functionArray: Array<any>) => {
    const data: any = {};
    functionArray.forEach((func, index) => {
      data[`func${index}`] = func;
    });
    return data;
  };
}

export default new BixolonLabelPrinterService();

const BixolonLabelPrinterConfig = {
  fontType: {
    s8: '1',
    s10: '2',
    s12: '3',
    s15: '4',
    s20: '5',
    s30: '6',
    s14: '7',
    s18: '8',
    s24: '9',
  },
  rotation: {
    None: 0,
    deg90: 1,
    deg180: 2,
    deg270: 3,
  },
  alignment: { left: 0, right: 1, Rtl: 2 },
  qrCodeSize: {
    s1: 1,
    s2: 2,
    s3: 3,
    s4: 4,
    s5: 5,
    s6: 6,
    s7: 7,
    s8: 8,
    s9: 9,
  },
};
export const labelPrinterCommand = {
  __config: BixolonLabelPrinterConfig,

  setWidth: (width: 500 | 576 | 832) => {
    return { setWidth: [width] };
  },
  setPrintingType: (type: 'direct' | 'transfer') => {
    return { setPrintingType: [type === 'direct' ? 'd' : 't'] };
  },
  setMargin: (horizontal: number, vertical: number) => {
    return { setMargin: [horizontal, vertical] };
  },
  clearBuffer: () => {
    return { clearBuffer: [] };
  },
  printBuffer: () => {
    return { printBuffer: [] };
  },
  printText: (text: string, x: number, y: number, fontType: string, rotation: number, isBold: boolean, alignment: number) => {
    return {
      drawDeviceFont: [text, x, y, fontType, 1, 1, rotation, 0, isBold, alignment],
    };
  },
  printQRCode: (data: string, x: number, y: number, size: number, rotation: number) => {
    return { drawQRCode: [data, x, y, 0, 'L', size, rotation] };
  },
  printImage: (data: string, x: number, y: number, width: number) => {
    return { drawBitmap: [data, x, y, width, false] };
  },
};
